// BHP-1088: Managed WordPress overview — Backend2.0 `GET /api/vps`, filtered to
// the `server-type=wordpress` label. Replaces the legacy
// `/api/v1/wordpress/hosting/servers` call that never resolved in the
// Backend2.0-only stack (infinite "please wait"). Rendering lives in the shared
// VpsServerList.
import VpsServerList from '../../features/vps/ui/VpsServerList';

export default function WordpressOverview(): JSX.Element {
  return (
    <VpsServerList
      serverType="wordpress"
      detailsBasePath="/vps/wordpress"
      noun="WordPress servers"
    />
  );
}
